module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fmtitle",
    attrs: {
      "id": "ded"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("This is dedicated to my first art teachers, Mr Mbaegu and Mr Idika Kalu. They saw this stuff in me and encouraged me at an early age to work hard and reach for the stars!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d597cf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Dedication.vue
// module id = 69
// module chunks = 0